export default __webpack_public_path__ + "static/media/pic1.c51dede5.jpg";